import { render, staticRenderFns } from "./AssessmentRegistrationStatus.vue?vue&type=template&id=6b8ed01a&scoped=true"
import script from "./AssessmentRegistrationStatus.vue?vue&type=script&lang=js"
export * from "./AssessmentRegistrationStatus.vue?vue&type=script&lang=js"
import style0 from "./AssessmentRegistrationStatus.vue?vue&type=style&index=0&id=6b8ed01a&prod&scoped=true&lang=css"
import style1 from "./AssessmentRegistrationStatus.vue?vue&type=style&index=1&id=6b8ed01a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8ed01a",
  null
  
)

export default component.exports